// 模板 11：SaaS 企业协同办公平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '企业协同与项目管理平台',
        content:
          '用一个平台连接团队、任务与文件，让协作更高效。'
      },
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '多端统一协同体验',
        content:
          'PC、Web 与移动端同步，随时随地处理工作事项。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '团队效率数据中心',
      subtitle: '/ Collaboration Analytics',
      paragraphs: [
        '从任务完成情况、沟通频率与项目进度三个维度分析团队协作效率。',
        '帮助管理者发现流程瓶颈，优化组织协作方式。'
      ],
      buttonText: '申请试用'
    },
    contact: {
      title: '中小企业数字化办公助手',
      subTitle: '让团队协作更轻松',
      buttonText: '预约演示'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '云协同科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注企业级协同办公 SaaS 产品，为各类团队提供轻量高效的项目与任务管理工具。',
      '我们希望用简单易用的产品，帮助更多团队告别低效沟通与信息孤岛。'
    ]
  },
  news: [
    {
      id: 'C01',
      title: '发布敏捷项目管理新版本',
      introduce:
        '新增 Scrum 看板与燃尽图等功能，更好支持研发团队的敏捷实践。',
      date: '02-09',
      year: '2025'
    },
    {
      id: 'C02',
      title: '与多家 IM 工具完成集成',
      introduce:
        '支持在主流即时通讯工具中直接接收任务通知与审批提醒。',
      date: '08-23',
      year: '2024'
    },
    {
      id: 'C03',
      title: '推出 OKR 管理模块',
      introduce:
        '帮助企业链接战略与日常工作，让目标管理更加落地。',
      date: '04-14',
      year: '2024'
    },
    {
      id: 'C04',
      title: '团队协作白皮书发布',
      introduce:
        '总结不同行业团队的协作实践与工具选型经验，为企业提供参考。',
      date: '11-20',
      year: '2023'
    },
    {
      id: 'C05',
      title: '上线自定义报表功能',
      introduce:
        '用户可根据自身管理需求配置多维度报表视图。',
      date: '06-05',
      year: '2023'
    }
  ],
  software: {
    smartTown: {
      title: '项目与任务管理模块',
      sections: [
        {
          heading: '1. 多项目协同',
          content:
            '支持多个项目并行管理，清晰呈现项目进度与负责人。'
        },
        {
          heading: '2. 任务分配与跟踪',
          content:
            '通过看板与列表视图管理任务，实时掌握执行情况。'
        },
        {
          heading: '3. 文件与讨论',
          content:
            '任务内支持附件与评论，减少沟通成本。'
        },
        {
          heading: '4. 通知与提醒',
          content:
            '通过多终端提醒确保重要事项不过期。'
        }
      ]
    },
    bigData: {
      title: '协同效率分析模块',
      sections: [
        {
          heading: '1. 任务完成情况统计',
          desc:
            '按项目与成员维度统计任务完成情况，识别负载不均与效率问题。'
        },
        {
          heading: '2. 项目进度健康度',
          desc:
            '识别里程碑滞后项目，提前预警风险。'
        },
        {
          heading: '3. 协作行为分析',
          desc:
            '统计评论与 @ 提及等互动行为，了解团队沟通模式。'
        },
        {
          heading: '4. 自定义统计视图',
          desc:
            '支持自定义统计维度与时间范围，满足不同管理需求。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '协同办公咨询',
      engTitle: 'Collaboration Consulting',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '企业落地辅导',
      engTitle: 'Onboarding Service',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '系统集成与单点登录',
      engTitle: 'SSO & Integration',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '定制化开发服务',
      engTitle: 'Customization',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: 'SaaS 产品顾问',
    responsibilities: [
      '负责协同办公产品的演示与方案讲解；',
      '根据客户反馈协助产品团队优化功能；',
      '参与整理行业最佳实践案例。'
    ],
    requirements: [
      '有 ToB SaaS 产品或售前经验者优先；',
      '学习能力强，善于与客户沟通；',
      '对提升团队协作效率有兴趣。'
    ],
    buttonText: '加入我们'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-11.js